import { __awaiter } from 'tslib';
import * as Long from 'long';
import { im_proto } from '../../proto/index.js';
import { IMEvent } from '../../core/consts.js';
import '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import { ServiceIdentity } from '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import * as JSONLong from 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import { BaseProcessor } from '../../core/service/processor/BaseProcessor.js';
import '../../core/model/CommandMessage.js';

var BlockType;
(function (BlockType) {
    BlockType[BlockType["BlockUser"] = 1] = "BlockUser";
    BlockType[BlockType["BlockConvNormalOnly"] = 2] = "BlockConvNormalOnly";
    BlockType[BlockType["BlockConvAll"] = 3] = "BlockConvAll";
})(BlockType || (BlockType = {}));
class BlockCmdProcessor extends BaseProcessor {
    process(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.data.type === im_proto.MessageType.MESSAGE_TYPE_BLOCK_COMMAND) {
                item.needContinue = false;
                this.handleBlockCmd(item.data, item.conv);
            }
            return item;
        });
    }
    handleBlockCmd(message, conv) {
        const content = JSONLong.parse(message.content);
        const blockStatus = content.block_status;
        if (content.type === BlockType.BlockUser) {
            const { userID } = content;
            if (userID === null || userID === undefined || userID.length === 0) {
                return;
            }
            const ps = this.resolve(ServiceIdentity.ParticipantManager).getMapRaw(conv.id);
            if (!ps) {
                return;
            }
            for (const user of userID) {
                const userIdStr = user === null || user === void 0 ? void 0 : user.toString();
                if (!ps.has(userIdStr)) {
                    continue;
                }
                const targetParticipant = ps.get(userIdStr);
                targetParticipant.blocked = Boolean(blockStatus);
                const curBlockTime = content.blockTime[userIdStr];
                targetParticipant.leftBlockTime = curBlockTime ? Long.fromValue(curBlockTime) : undefined;
                // leftBlockTime
                this.resolve(ServiceIdentity.ParticipantManager).upsert(conv.id, targetParticipant);
                this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ParticipantBlock, this, {
                    participant: targetParticipant,
                    message
                });
            }
        }
        else {
            this.resolve(ServiceIdentity.ConversationManager)
                .refreshAsync(conv)
                .then(newConvs => {
                newConvs.map(newConv => this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ConversationBlock, this, {
                    conversation: newConv,
                    message
                }));
            });
        }
    }
}

export { BlockCmdProcessor, BlockType };
//# sourceMappingURL=BlockCmdProcessor.js.map
